import React, { useState } from "react"
import { Modal, message } from "antd"
import { organizationApi } from "../../Apis/organizationApi"
import {
  parseOrganizationApiError,
  unwrapOrganizationResult,
} from "../../utils/organizationApiHelpers"
import { translations } from "../../utils/Translation/staticTranslation"
import { getAppLanguage } from "../../utils/getAppLanguage"

const ReclaimOrganizationMemberModal = ({
  open,
  onClose,
  onSuccess,
  member,
  showFurnitureFinder = false,
}) => {
  const [submitting, setSubmitting] = useState(false)
  const lang = getAppLanguage()
  const t = translations[lang]?.organizationPage?.reclaimModal

  const handleReclaim = async () => {
    if (!member?.id) return
    setSubmitting(true)
    try {
      const response = await organizationApi.reclaimMember(member.id, {})
      const result = unwrapOrganizationResult(response)
      const reclaimedImages = result?.reclaimed_images ?? 0
      const reclaimedFurnitureFinder = result?.reclaimed_furniture_finder ?? 0
      const successMessage =
        showFurnitureFinder && reclaimedFurnitureFinder > 0
          ? t?.successWithFurnitureFinder
              ?.replace("{images}", String(reclaimedImages))
              ?.replace("{furnitureFinder}", String(reclaimedFurnitureFinder))
          : t?.success?.replace("{count}", String(reclaimedImages))
      message.success(successMessage || t?.success)
      onSuccess?.(result)
      onClose()
    } catch (error) {
      message.error(parseOrganizationApiError(error, lang))
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal
      className="org-modal"
      title={t?.title}
      open={open}
      onCancel={onClose}
      onOk={handleReclaim}
      okText={t?.confirm}
      cancelText={t?.cancel}
      confirmLoading={submitting}
      okButtonProps={{
        className: "org-reclaim-confirm-btn",
        style: {
          background: "#504943",
          borderColor: "#504943",
          borderRadius: 8,
        },
      }}
      cancelButtonProps={{
        style: { borderRadius: 8 },
      }}
    >
      <p className="text-14 text-484747">
        {t?.body?.replace("{email}", member?.email || "")}
      </p>
      <p className="text-14 text-A1A1A1 mt-12">
        {t?.hint?.replace(
          "{remaining}",
          String(member?.remaining_images ?? 0),
        )}
      </p>
      {showFurnitureFinder ? (
        <p className="text-14 text-A1A1A1 mt-8">
          {t?.furnitureFinderHint?.replace(
            "{remaining}",
            String(member?.remaining_furniture_finder ?? 0),
          )}
        </p>
      ) : null}
    </Modal>
  )
}

export default ReclaimOrganizationMemberModal
